import {
  Env,
  getHostName,
  isLocalNetwork,
} from '@allen-career-institute/allen-web-common/dist/src/lib/app-shell/AppEnv'

interface EnvValues {
  API_BASE_URL: string
  ADMIN_API_BASE_URL: string
  API_ROOT_BASE_URL: string
  NODE_ENV: string
  QB_CONCEPT_CARD_EDIT_URL: string
  ENV_KEY: string
  SCHOOL_MANAGE_API_BASE_URL: string
}

export type NODE_ENVS = 'PROD' | 'DEV' | 'STAGE'
type NODE_ENV_VALS = 'production' | 'development' | 'stage'
type EnvValue<T> = {
  [key in NODE_ENVS]: T
}

const NODE_ENV_VALUE: EnvValue<NODE_ENV_VALS> = {
  PROD: 'production',
  STAGE: 'stage',
  DEV: 'development',
}

const API_BASE_URLS: EnvValue<string> = {
  PROD: 'https://api.allen-live.in/internal-bff/',
  STAGE: 'https://bff.allen-stage.in/internal-bff/',
  DEV: 'https://bff-dev.allen-demo.in/internal-bff/',
}

const SCHOOL_MANAGE_API_BASE_URLS: EnvValue<string> = {
  PROD: 'https://api.allen-live.in/',
  STAGE: 'https://bff.allen-stage.in/',
  DEV: 'https://devalschool.hashstudioz.com/',
}

const ADMIN_API_BASE_URLS: EnvValue<string> = {
  PROD: 'https://api.allen-live.in/admin/',
  STAGE: 'https://bff.allen-stage.in/admin/',
  DEV: 'https://bff-dev.allen-demo.in/admin/',
}

const API_ROOT_BASE_URLS: EnvValue<string> = {
  PROD: 'https://api.allen-live.in/',
  STAGE: 'https://bff.allen-stage.in/',
  DEV: 'https://bff-dev.allen-demo.in/',
}

const QB_CONCEPT_CARD_EDIT_URLS: EnvValue<string> = {
  DEV: 'http://qbstaging.allen.ac.in',
  STAGE: 'http://qbstaging.allen.ac.in',
  PROD: 'https://qb.allen.ac.in',
}

function getNodeEnvfromEnv(env: Env | undefined): NODE_ENVS | undefined {
  switch (env) {
    case Env.DEV:
      return 'DEV'
    case Env.STAGE:
      return 'STAGE'
    case Env.PROD:
      return 'PROD'
  }
  return undefined
}
declare global {
  interface Window {
    NEXT_PUBLIC_FORCE_ENV?: any // or specific type instead of `any`
  }
}

export function getEnvToOverride(): Env | undefined {
  if (!process.env.NEXT_PUBLIC_FORCE_ENV) return
  if (process.env.NODE_ENV === 'production') {
    console.warn(
      'NOT overriding env since NODE_ENV is production',
      process.env.NEXT_PUBLIC_FORCE_ENV,
    )
    return
  }
  console.warn('ENV OVERRIDEN BY FORCE_ENV to:', process.env.NEXT_PUBLIC_FORCE_ENV)
  switch (process.env.NEXT_PUBLIC_FORCE_ENV) {
    case 'DEV':
      return Env.DEV
    case 'STAGE':
      return Env.STAGE
    case 'PROD':
      return Env.PROD
    default:
      console.warn('Invalid FORCE_ENV:', process.env.NEXT_PUBLIC_FORCE_ENV)
  }
  return undefined
}

export const getCurrentEnvValues = (req?: {
  headers: { get: (key: string) => string | null }
}): EnvValues => {
  const host: string | undefined = getHostName(req)
  const envToOverride = getNodeEnvfromEnv(getEnvToOverride())
  let env: NODE_ENVS = 'PROD'
  if (envToOverride) {
    env = envToOverride
  } else {
    if (!host) {
      console.warn("Couldn't determine host. Using production environment.")
    } else {
      // determine env from hostname
      if (isLocalNetwork(host) || host.includes('dev') || host.includes('demo')) {
        env = 'DEV'
      } else if (host.includes('stage')) {
        env = 'STAGE'
      }
    }
  }
  const API_BASE_URL = API_BASE_URLS[env]
  const ADMIN_API_BASE_URL = ADMIN_API_BASE_URLS[env]
  const API_ROOT_BASE_URL = API_ROOT_BASE_URLS[env]
  const NODE_ENV = NODE_ENV_VALUE[env]
  const QB_CONCEPT_CARD_EDIT_URL = QB_CONCEPT_CARD_EDIT_URLS[env]
  const SCHOOL_MANAGE_API_BASE_URL = SCHOOL_MANAGE_API_BASE_URLS[env]

  return {
    API_BASE_URL,
    ADMIN_API_BASE_URL,
    API_ROOT_BASE_URL,
    NODE_ENV,
    QB_CONCEPT_CARD_EDIT_URL,
    ENV_KEY: env,
    SCHOOL_MANAGE_API_BASE_URL,
  }
}

export const ENV = getCurrentEnvValues()
